import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=64c8f24e&scoped=true"
import script from "./SchoolList.vue?vue&type=script&lang=js"
export * from "./SchoolList.vue?vue&type=script&lang=js"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=64c8f24e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8f24e",
  null
  
)

export default component.exports